"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    overflow: prop_types_1.default.string,
    overflowX: prop_types_1.default.string,
    overflowY: prop_types_1.default.string
};
exports.propAliases = {
    overflow: ['overflowX', 'overflowY']
};
exports.propValidators = {};
const overflowY = {
    className: 'ovflw-y',
    cssName: 'overflow-y',
    jsName: 'overflowY',
    safeValue: true
};
const overflowX = {
    className: 'ovflw-x',
    cssName: 'overflow-x',
    jsName: 'overflowX',
    safeValue: true
};
exports.propEnhancers = {
    overflowX: (value) => get_css_1.default(overflowX, value),
    overflowY: (value) => get_css_1.default(overflowY, value)
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3ZlcmZsb3cuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZW5oYW5jZXJzL292ZXJmbG93LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsNERBQWtDO0FBQ2xDLHlEQUErQjtBQUdsQixRQUFBLFNBQVMsR0FBcUI7SUFDekMsUUFBUSxFQUFFLG9CQUFTLENBQUMsTUFBTTtJQUMxQixTQUFTLEVBQUUsb0JBQVMsQ0FBQyxNQUFNO0lBQzNCLFNBQVMsRUFBRSxvQkFBUyxDQUFDLE1BQU07Q0FDNUIsQ0FBQTtBQUVZLFFBQUEsV0FBVyxHQUFnQjtJQUN0QyxRQUFRLEVBQUUsQ0FBQyxXQUFXLEVBQUUsV0FBVyxDQUFDO0NBQ3JDLENBQUE7QUFFWSxRQUFBLGNBQWMsR0FBbUIsRUFBRSxDQUFBO0FBRWhELE1BQU0sU0FBUyxHQUFHO0lBQ2hCLFNBQVMsRUFBRSxTQUFTO0lBQ3BCLE9BQU8sRUFBRSxZQUFZO0lBQ3JCLE1BQU0sRUFBRSxXQUFXO0lBQ25CLFNBQVMsRUFBRSxJQUFJO0NBQ2hCLENBQUE7QUFDRCxNQUFNLFNBQVMsR0FBRztJQUNoQixTQUFTLEVBQUUsU0FBUztJQUNwQixPQUFPLEVBQUUsWUFBWTtJQUNyQixNQUFNLEVBQUUsV0FBVztJQUNuQixTQUFTLEVBQUUsSUFBSTtDQUNoQixDQUFBO0FBRVksUUFBQSxhQUFhLEdBQWtCO0lBQzFDLFNBQVMsRUFBRSxDQUFDLEtBQTRCLEVBQUUsRUFBRSxDQUFDLGlCQUFNLENBQUMsU0FBUyxFQUFFLEtBQUssQ0FBQztJQUNyRSxTQUFTLEVBQUUsQ0FBQyxLQUE0QixFQUFFLEVBQUUsQ0FBQyxpQkFBTSxDQUFDLFNBQVMsRUFBRSxLQUFLLENBQUM7Q0FDdEUsQ0FBQSJ9